import React from 'react';
import ClassleaderElection2023 from 'views/ClassleaderElection2023';

const LifeSkillPage = () => {
  return <ClassleaderElection2023/>;
};

export default LifeSkillPage;